import React from 'react';
import PropTypes from 'prop-types';
import { Spacing, Text, Icon, Badge } from '@reservamos/elements';
import { useTranslation } from 'react-i18next';

/**
 * OverbookingBadge component.
 * @param {object} props - hasIcon.
 * @param {boolean} props.hasIcon - Whether to display the bus icon.
 * @returns {React.Element}
 */
const OverbookingBadge = ({ hasIcon }) => {
  const { t } = useTranslation('general');

  return (
    <Spacing size="XS">
      {hasIcon && <Icon type="BusStand" />}
      <Badge alphaBg="L" smallPadding roundCorners type="accent">
        <Text color="primary" elementType="span" size="XS" weight="semibold">
          <em>{t('text.no_assigned_seat')}</em>
        </Text>
      </Badge>
    </Spacing>
  );
};

OverbookingBadge.propTypes = {
  hasIcon: PropTypes.bool,
};

OverbookingBadge.defaultProps = {
  hasIcon: false,
};

export default OverbookingBadge;
